import React from 'react'

import close from "./../../../UI/general/close.svg"
import asoleacion from "./../../../UI/asoleacion/modalIcon.svg"

interface Props {
  handleAsoleacionImagesCount: any,
  asoleacionCurrentSetCount: any,
  handleAsoleacionChangeIndex: any,
  isAsoleacionModalOpened: boolean,
  handleOpenAsoleacionModel: any,
  asolacionData: any,
  colorsData: any,
  handleChangeAsoleacionTime: any,
  asoleacionCurrentSetIndex: any,
  handleChangeAsoleacionSet: any,
  handleAutoplayAsoleacion: any,
  asoleacionCurrentSet: any
}

interface State {}

class AsoleacionUI extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isAsoleacionModalOpened ? "asoleacion-modal-opened":"asoleacion-modal-closed"}>
          <div 
            className="asoleacion-modal-close-btn"
            onClick={() => {
              this.props.handleOpenAsoleacionModel()
            }}
          >
            <img src={close} alt=""/>
          </div>
          <div className="asoleacion-modal-icon-general">
            <img src={asoleacion} alt=""/>
          </div>
          <div className="asoelacion-modal-title">
            ASOLEACIÓN
          </div>
          <div className="asoleacion-buttons-container">
            {
              this.props.asolacionData && this.props.asolacionData.times ?
              this.props.asolacionData.times.map((time: any, index: number) => 
                <div 
                  className="asoleacion-times-btn-individual"
                  key={time.name + index}
                  style={{
                    bottom: time.bottom
                  }}
                  onClick={() => {this.props.handleChangeAsoleacionTime(time.frame)}}
                >
                <div className="asoleacion-times-image-container" onClick={() => {this.props.handleChangeAsoleacionTime(time.frame)}}>
                  <img src={time.icon} alt=""/>
                  </div>
                  <div className="asoleacion-times-name">
                    {time.name}
                  </div>
                </div>
              ):null
            }
            </div>
            <div className="asoleacion-input-container">
              <input 
                type='range' 
                step={1} 
                min={0}
                max={this.props.asoleacionCurrentSetCount - 1} 
                onChange={(e: any) => {this.props.handleAsoleacionChangeIndex(e.target.value * 1)}}
                value={this.props.asoleacionCurrentSetIndex}
                ></input>
            </div>

            <div className="asoleacion-vistas-container">
              <div className="asoleacion-vistas-title">Vistas</div>
              <div className="vistas-btn-container">
                {
                  this.props.asolacionData && this.props.asolacionData.vistas ?
                  this.props.asolacionData.vistas.map((vista: any, index: number) =>
                    <div 
                      key={vista.name + index}
                      className="asoleacion-vistas-btn-individual"
                      onClick={
                        index !== 3 ? 
                        () => {this.props.handleChangeAsoleacionSet(vista)}:
                        () => {this.props.handleAutoplayAsoleacion()}
                      }
                      style={{
                        backgroundColor: this.props.asoleacionCurrentSet.name === vista.name ? this.props.colorsData.main_buttons:'',
                        color: this.props.asoleacionCurrentSet.name === vista.name ? this.props.colorsData.secondary_text:''
                      }}
                    >
                      {vista.name}
                    </div>
                    ):null
                  }
                </div>
          </div>
        </div>
      )
  }
}

export default AsoleacionUI